export default function ProgressBar({ value, max = 100, tone = "primary", showValue = false, size = "md", label = "Progress" }) {
  const pct = value === null || value === undefined ? 0 : Math.max(0, Math.min(100, (Number(value) / max) * 100));
  return (
    <div className={`progress progress-${size}`}>
      <div className="progress-track" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100} aria-label={label}>
        <div className={`progress-fill tone-${tone}`} style={{ width: `${pct}%` }} />
      </div>
      {showValue && <span className="progress-value">{value === null || value === undefined ? "—" : `${Math.round(pct)}%`}</span>}
    </div>
  );
}
